'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableWithoutFeedback, Keyboard, ScrollView, Image} from 'react-native';
import Icon from '../../../../components/Icon'
import styles from './style';
import {scroll} from '../../../../common/utils';
import ReactDom from 'react-dom';

class GoTop extends Component {
    constructor(props) {
        super(props);
    }

    scrollToTop = () => {
        GodEye.log({
            r: 'go_top_click'
        });
        scroll(ReactDom.findDOMNode(this.props.scrollRef), 0);
    };

    componentDidUpdate() {
        if(this.props.show) {
            GodEye.log({
                r: 'go_top_show'
            });
        }
    }

    render() {
        if(!this.props.show) {
            return <View />
        }
        return (
            <TouchableWithoutFeedback onPress={this.scrollToTop}>
                <View style={styles.goTopWrapper}>
                    <Icon name='goTop' style={styles.goTopIcon} size={24} color={'#333333'}/>
                </View>
            </TouchableWithoutFeedback>
        )
    }
}

export default GoTop;
